import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useLocation } from "react-router-dom";
import { UpdateProjectAllDetails, AddContractor, ViewAmountModel } from "../SiteManagement/ProjectDetailsCrudButtons";
import { BillingDetailsTable, BillTable, ConsultancyDetails, ContractorDetails, COSTable, EmployeeTable, EOTTable, LetterTracking, MilestoneTable, MiscellaneousDocument, Progress } from "../SiteManagement/SiteProjectManagement";
import usePermission from "../../config/permissions";
import { VehicleModelTable } from "../SiteManagement/VehicleManagement/VehicleManagementComponenets";
import { SiteInventory } from "../SiteManagement/InventoryManagement/InventoryManagementComponent";
import { UploadBulkContractor } from "../SiteManagement/BulkModals";
import { toast } from 'react-toastify';

import ReactToPrint from 'react-to-print';
import { formatDateDD_MM_YYYY, formattedDateLong, datearray } from "../Date";
import { AddProjectBill, AddEOTDetails, AddCOSDetails, AddMilstoneDetails, AddTrackRecordDetails, UpdateTrackRecordDetails, AddProgressdetails, DeleteBillingDetails, UpdateBill, UpdateProjectBill, DeleteBg, DeleteInsurance, AddInsurance, AddBankGuarantee, UpdateContractor, DeleteContractor, UpdateBankGuarantee, UpdateBank, UpdateInsurance, UpdateEOTDetails, DeleteEOT, DeleteTrackAndLetterDetails, DeleteCOS, UpdateTrackRecordDetailwithIDonly, UpdateConsultantDetails, AssociatedLetters, DocumentModel, DeleteDocuments, UpdateProgressdetails, UpdateCOSDetails, UpdateMilestone, DeleteMileStone } from "../SiteManagement/ProjectDetailsCrudButtons";
import { AddSiteEmployee, UpdateSiteEmployee, DeleteSiteEmployee, UploadSiteEmployee } from "../Wfm/WorkforceCrudButton";
import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, YAxis, LineChart } from 'recharts';
import { DownloadTableExcel } from "react-export-table-to-excel";
import { formatCurrencyIndian, sortProjects, handleErrorToast, formatRoundoffCrores, formatRoundoff, DateRangePicker, ViewLetterModal } from "../CustomFunctions";
import { CircularGrid, DeleteDustbin, DocumentIcon, SearchBig, SearchSmall, AddwithWhiteCircle, Reciept, UpdatePencil, Employee, Calender, Month, Year, Pending } from '../AllSvg';
import { LetterStatus, LetterType, Projects, ContractorFilter, SubCompanyModern, YearModern, MonthModern, ContractorModern } from '../FilterDropdown';
import { UploadBGBulk, UploadBillingBulk, UploadcosBulk, UploadEotBulk, UploadInsuranceBulk, UploadLetterBulk, UploadMilestoneBulk, UploadSiteProgressBulk, VehicleModelBulk } from '../SiteManagement/BulkModals';
import { Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { AddLetterLinked } from '../../pages/sitedashboard/Main/LetterTracking';
import Item from 'antd/es/list/Item';

import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { height, width } from '@mui/system';
import Select from 'react-select';
import SkeletonLoader from '../Skeletonloader';
import { formatDate } from '../../components/Date.jsx'


import { SubCompany } from "../FilterDropdown";
import * as XLSX from 'xlsx';

import StatusBar from "../StatusBar/StatusBar.jsx";
import { Activity, AlertCircle, ArrowRight, Award, BarChart3, Briefcase, Building2, Calendar, CalendarCheck, CalendarClock, CheckCircle, ChevronDown, ChevronUp, ClipboardX, Clock, Cross, DownloadCloudIcon, FileCheck, FileSearch, FileSpreadsheet, FileText, FileX, Filter, Flag, IndianRupee, Landmark, Milestone, Receipt, ShieldCheck, Sparkles, Users, Wallet, X } from "lucide-react";
import AllAssociatedLetters from "../SiteManagement/AllAssociatedLetters.jsx";


const DownloadSiteProject = ({ progressdata }) => {
    const downloadXLSX = () => {
        if (!progressdata || progressdata.length === 0) {
            alert("No data available to download!")
            return
        }

        let data = []
        let sheetName = "Report"
        let urlCells = [] // Track cells that contain URLs for later formatting

        if (progressdata[0].hasOwnProperty("month") && progressdata[0].hasOwnProperty("year")) {
            data = [
                [
                    "S.No",
                    "Contractor",
                    "Month",
                    "Year",
                    "Submitted Physical Progress",
                    "Submitted Financial Progress",
                    "Approved Physical Progress",
                    "Approved Financial Progress",
                ],
            ]
            sheetName = "Progress_Report"

            progressdata.forEach((item, index) => {
                const contractor = item.contractor_name || "-"
                const month = item.month ? item.month : "-"
                const year = item.year || "-"
                const submittedPhysical = item.submitted_physical_progress || "-"
                const submittedFinancial = item.submitted_financial_progress || "-"
                const approvedPhysical = item.physical_progress || "-"
                const approvedFinancial = item.financial_progress || "-"

                data.push([
                    index + 1,
                    contractor,
                    month,
                    year,
                    submittedPhysical,
                    submittedFinancial,
                    approvedPhysical,
                    approvedFinancial,
                ])
            })
        }
        else if (progressdata[0].hasOwnProperty("eot_code")) {
            data = [
                [
                    "S.No",
                    "Project Code",
                    "Project Name",
                    "EOT Code",
                    "Contractor",
                    "No. of Days",
                    "Initiated Date",
                    "Approval Date",
                ],
            ]
            sheetName = "EOT_Report"

            progressdata.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.project_code || "-",
                    item.project_short_name || "-",
                    item.eot_code || "-",
                    item.contractor_name || "-",
                    item.approved_days || "-",
                    item.process_initiate_date || "-",
                    item.approved_date || "-",
                ])
            })
        }
        else if (progressdata[0].hasOwnProperty("cos_code")) {
            data = [
                ["S.No", "Project Code", "Project Name", "COS Code", "Contractor", "Amount", "Initiated Date", "Approval Date"],
            ]
            sheetName = "COS_Report"

            progressdata.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.project_code || "-",
                    item.project_short_name || "-",
                    item.cos_code || "-",
                    item.contractor_name || "-",
                    item.amount || "-",
                    item.process_initiate_date || "-",
                    item.approval_date || "-",
                ])
            })
        }
        else if (progressdata[0].hasOwnProperty("name") && progressdata[0].hasOwnProperty("milestone_date")) {
            data = [
                [
                    "S.No",
                    "Project Code",
                    "Project Name",
                    "Milestone Name",
                    "Contractor",
                    "Milestone Date",
                    "Milestone Days",
                    "Actual Date",
                    "Reschedule Date",
                ],
            ]
            sheetName = "Milestone_Report"

            progressdata.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.site_prcode || "-",
                    item.project_name || "-",
                    item.name || "-",
                    item.contractor_name || "-",
                    item.milestone_date || "-",
                    item.day || "-",
                    item.milestone_as_per_actual || "-",
                    item.milestone_as_per_reschedule || "-",
                ])
            })
        }
        else if (progressdata[0].hasOwnProperty("bill_num")) {
            data = [
                [
                    "S.No",
                    "Project Code",
                    "Project Name",
                    "Contractor",
                    "Bill Number",
                    "Bill Type",
                    "Bill Category",
                    "Submitted Date",
                    "Submitted Amount",
                    "Recommended Date",
                    "Recommended Amount",
                ],
            ]
            sheetName = "Billing_Report"

            progressdata.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.project_code || "-",
                    item.project_short_name || "-",
                    item.contractors_names || "-",
                    item.bill_num || "-",
                    item.bill_type || "-",
                    item.bill_catagory || "-",
                    item.submitted_bill_date || "-",
                    item.submitted_bill_amount || "-",
                    item.recomended_bill_date || "-",
                    item.recommended_bill_amount || "-",
                ])
            })
        }
        else if (progressdata[0].hasOwnProperty("bg_num")) {
            data = [["S.No", "Bank Name", "Bank Number", "Amount", "Start Date", "Expiry Date", "Remarks"]]
            sheetName = "BG_Report"

            progressdata.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.bank_name || "-",
                    item.bg_num || "-",
                    item.bg_amount || "-",
                    item.bg_date || "-",
                    item.bg_expiry_date || "-",
                    item.bg_remark || "-",
                ])
            })
        }
        else if (progressdata[0].hasOwnProperty("insurance_policy_num")) {
            data = [["S.No", "Policy Number", "Insurance Name", "Amount", "Start Date", "Valid Upto", "File"]]
            sheetName = "Insurance_Report"

            progressdata.forEach((item, index) => {
                const rowIndex = index + 1;
                const urlColumn = 6;

                const url = item.insurance_file_upload || "-";
                if (url !== "-" && isValidURL(url)) {
                    urlCells.push({
                        row: rowIndex + 1,
                        col: urlColumn,
                        url: url,
                        text: "View"
                    });
                }

                data.push([
                    index + 1,
                    item.insurance_policy_num || "-",
                    item.insurance_name || "-",
                    item.insurance_amount || "-",
                    item.insurance_policy_start_date || "-",
                    item.insurance_policy_valid_upto_date || "-",
                    url !== "-" && isValidURL(url) ? "View" : url,
                ])
            })
        }
        else {
            const headers = Object.keys(progressdata[0])
            data.push(["S.No", ...headers])

            progressdata.forEach((item, index) => {
                const row = [index + 1];

                headers.forEach((key, colIndex) => {
                    const value = item[key] || "-";


                    if (typeof value === 'string' && isValidURL(value)) {

                        urlCells.push({
                            row: index + 2,
                            col: colIndex + 1,
                            url: value,
                            text: "View"
                        });
                        row.push("View");
                    } else {
                        row.push(value);
                    }
                });

                data.push(row);
            })
            sheetName = "Data_Report"
        }

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(data);


        ws['!cols'] = data[0].map((_, i) => ({
            wch: Math.max(...data.map(row => (row[i] || "").toString().length))
        }));


        urlCells.forEach(cell => {
            const cellRef = XLSX.utils.encode_cell({ r: cell.row, c: cell.col });


            if (!ws[cellRef]) {
                ws[cellRef] = { t: 's', v: cell.text };
            }


            if (!ws[cellRef].l) {
                ws[cellRef].l = { Target: cell.url };
            }
        });

        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, `${sheetName}.xlsx`)
    };


    const isValidURL = (string) => {
        try {

            if (string.match(/^https?:\/\//i)) {
                return true;
            }
            return false;
        } catch (err) {
            return false;
        }
    };

    return (
        <>
            <button onClick={downloadXLSX} title="Download" className=" att-icon-btn" style={{ backgroundColor: "black" }}>
                <DownloadCloudIcon size={20} color="white" />
            </button>
        </>
    );
};



const Progressreport = () => {
    const [showFilters, setShowFilters] = useState(true);

    const [progress, setProgress] = useState([]);
    const [contractorlist, setContractorList] = useState([]);
    const [buffer, setBuffering] = useState(false);
    const [loading, setLoading] = useState(false);
    const role = sessionStorage.getItem('sitemanagement_role');
    const [toggleCompany, setToggleCompany] = useState("null");
    const [filterMonth, setFilterMonth] = useState(() => new Date().getMonth() + 1);
    const [filterYear, setFilterYear] = useState(new Date().getFullYear());
    const [project, setProject] = useState("null");
    const [contractorId, setcontractorId] = useState("null");
    const [expandedRow, setExpandedRow] = useState(null);
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20;
    const endYear = currentYear + 20;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);

    const [progressdata, setProgressData] = useState([]);

    const getProgress = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/progressbyproject/${project}/${contractorId}/${filterMonth}/${filterYear}/`);
            setProgressData(response.data);

            const sortedData = response.data.sort((a, b) => {
                if (a.year === b.year) return b.month - a.month;
                return b.year - a.year;
            });
            setProgress(sortedData);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getProgress();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project, contractorId, filterMonth, filterYear]);

    const handleProgressDelete = async (e, i) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            let res = await axios.delete(`${BASE_URL}/siteproject/progressupdate/${i.id}/`);
            if (res.status === 200) {
                await getProgress();
                toast.success("Progress deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const getMonthName = (monthNumber) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[monthNumber - 1];
    };

    const getContractor = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${project}/null/`);
            setContractorList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getContractor();
    }, [project]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    return (
        <div className="progress-modern-container">


            {role !== "SiteManagement" && (
                <>
                    {showFilters && (
                        <div className="filter-bar-attractive">



                            <div className="filter-group-attractive">
                                <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                    <div className="filter-chip-content">
                                        <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                                    </div>
                                </div>

                                <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                                    <div className="filter-chip-content">
                                        <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                                    </div>
                                </div>

                                <div className="filter-chip" style={{ padding: '0px' }}>
                                    <div className="filter-chip-content">
                                        <MonthModern filterMonth={filterMonth} setFilterMonth={setFilterMonth} cssType="modern" />
                                    </div>
                                </div>

                                <div className="filter-chip" style={{ padding: '0px' }}>
                                    <div className="filter-chip-content">
                                        <YearModern filterYear={filterYear} setFilterYear={setFilterYear} cssType="modern" />
                                    </div>
                                </div>

                                <div className={`filter-chip ${contractorId !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                    <div className="filter-chip-content">
                                        <ContractorModern contractorId={contractorId}
                                            setcontractorId={setcontractorId} cssType="modern" project={project}
                                            subcompany={toggleCompany} />
                                    </div>
                                </div>

                                {(toggleCompany !== "null" || project !== "null" || contractorId !== "null") && (
                                    <button
                                        className="clear-filters-btn"
                                        onClick={() => {
                                            setToggleCompany("null");
                                            setProject("null");
                                            setcontractorId("null");
                                        }}
                                    >
                                        <X size={13} />
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
            {/* Stats Summary */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <BarChart3 size={14} />
                        <span>Showing</span>
                        <strong>{progress.length} records</strong>
                    </div>

                </div>
                <div className="filter-bar-top" style={{ width: "20%", gap: "10px", }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive">
                        <DownloadSiteProject progressdata={progressdata} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno  " style={{ width: '5%' }}>#</th>
                                <th className="col-period " style={{ width: '10%' }}>Period</th>
                                <th className="col-period text-center" >Contractor / Letters</th>
                                <th className="col-submitted text-center " style={{ width: '15%' }}>Submitted</th>
                                <th className="col-approved text-center" style={{ width: '15%' }}>Approved</th>
                            </tr>
                        </thead>
                        <tbody>
                            {progress.map((item, index) => {
                                const contractorData = contractorlist.find(c => c.id === item.contractor);
                                const isExpanded = expandedRow === index;

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                {getMonthName(item.month)} {item.year}
                                            </td>
                                            <td className="col-period" >


                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Calendar size={12} />
                                                    <span>{contractorData ? contractorData.name : "-"} </span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                            </td>
                                            <td className="col-submitted">
                                                <div className="progress-badge">
                                                    <span className="badge-label">Physical</span>
                                                    <span className="badge-value">{item.submitted_physical_progress || 0}%</span>
                                                </div>
                                                <div className="progress-badge">
                                                    <span className="badge-label">Financial</span>
                                                    <span className="badge-value">{item.submitted_financial_progress || 0}%</span>
                                                </div>
                                            </td>
                                            <td className="col-approved">
                                                <div className="progress-badge approved">
                                                    <span className="badge-label">Physical</span>
                                                    <span className="badge-value">{item.physical_progress || 0}%</span>
                                                </div>
                                                <div className="progress-badge approved">
                                                    <span className="badge-label">Financial</span>
                                                    <span className="badge-value">{item.financial_progress || 0}%</span>
                                                </div>
                                            </td>

                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={5}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Letter Details</span>
                                                            </div>
                                                        </div>

                                                        <div className="letters-section-attractive">
                                                            <div className={`letter-card-attractive ${item.submitted_letter ? 'has-letter' : ''}`}>
                                                                <div className="letter-card-glow submitted-glow" />
                                                                <div className="letter-header-attractive">
                                                                    <div className="letter-icon-wrap submitted">
                                                                        <FileText size={15} />
                                                                    </div>
                                                                    <div className="letter-header-text">
                                                                        <span className="letter-title">Submitted Letter</span>
                                                                        <span className="letter-subtitle">Uploaded by contractor</span>
                                                                    </div>
                                                                    <div className={`letter-status-dot ${item.submitted_letter ? 'active' : 'inactive'}`} />
                                                                </div>
                                                                <div className="letter-body-attractive">
                                                                    {item.submitted_letter ? (
                                                                        <ViewLetterModal i={item.submitted_letter} usedFor="nestedTable" />
                                                                    ) : (
                                                                        <div className="no-letter-attractive">
                                                                            <FileX size={16} />
                                                                            <span>No letter attached</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="letter-connector">
                                                                <ArrowRight size={14} />
                                                            </div>

                                                            <div className={`letter-card-attractive ${item.approved_letter ? 'has-letter' : ''}`}>
                                                                <div className="letter-card-glow approved-glow" />
                                                                <div className="letter-header-attractive">
                                                                    <div className="letter-icon-wrap approved">
                                                                        <CheckCircle size={15} />
                                                                    </div>
                                                                    <div className="letter-header-text">
                                                                        <span className="letter-title">Approved Letter</span>
                                                                        <span className="letter-subtitle">Verified & signed off</span>
                                                                    </div>
                                                                    <div className={`letter-status-dot ${item.approved_letter ? 'active' : 'inactive'}`} />
                                                                </div>
                                                                <div className="letter-body-attractive">
                                                                    {item.approved_letter ? (
                                                                        <ViewLetterModal i={item.approved_letter} usedFor="nestedTable" />
                                                                    ) : (
                                                                        <div className="no-letter-attractive">
                                                                            <FileX size={16} />
                                                                            <span>No letter attached</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {progress.length === 0 && (
                                <tr>
                                    <td colSpan={5}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <FileSearch size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Progress Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or select a different month/year to view records.
                                            </p>
                                            {(toggleCompany !== "null" || project !== "null" || contractorId !== "null") && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setToggleCompany("null");
                                                        setProject("null");
                                                        setcontractorId("null");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div >
    );
};




const EOTDetails = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [eotData, setEotData] = useState([]);
    const [buffer, setbuffer] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [project, setProject] = useState("null");
    const [contractorId, setcontractorId] = useState("null");
    const [toggleCompany, setToggleCompany] = useState("null");
    const [workperformedby, setWorkperformedby] = useState("contractor");
    const [expandedRow, setExpandedRow] = useState(null);

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [approvefromdate, setApproveFromDate] = useState("null");
    const [approvetodate, setApproveToDate] = useState("null");

    const [error, setError] = useState(null);
    const [status, setStatus] = useState('pending');

    const fetchEOTData = async () => {
        setbuffer(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/eotfilter/${project}/${workperformedby}/${contractorId}/${status}/${fromdate}/${todate}/${approvefromdate}/${approvetodate}/`);
            setEotData(response.data);
        } catch (err) {
            setError('Failed to fetch EOT data');
        } finally {
            setbuffer(false);
        }
    };

    useEffect(() => {
        if (workperformedby === "consultant" || status === "pending") {
            setApproveFromDate("null");
            setApproveToDate("null");
            setcontractorId("null");
        }
        if (status === "Approved") {
            setFromDate("null");
            setToDate("null");
        } else {
            setFromDate("null");
            setToDate("null");
        }
    }, [workperformedby, status]);

    useEffect(() => {
        fetchEOTData();
    }, [project, status, contractorId, fromdate, todate, approvefromdate, approvetodate, workperformedby]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const hasActiveFilters = toggleCompany !== "null" || project !== "null" || contractorId !== "null";

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                            </div>
                        </div>

                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-icon"><Clock size={13} /></div>
                            <div className="filter-chip-content">
                                <span className="filter-chip-label">Status</span>
                                <select
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    className="modern-select"
                                >
                                    <option value="pending">Pending</option>
                                    <option value="Approved">Approved</option>
                                </select>
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-icon"><Users size={13} /></div>
                            <div className="filter-chip-content">
                                <span className="filter-chip-label">Letter For</span>
                                <select
                                    value={workperformedby}
                                    onChange={(e) => setWorkperformedby(e.target.value)}
                                    className="modern-select"
                                >
                                    <option value="consultant">Consultant</option>
                                    <option value="contractor">Contractor</option>
                                </select>
                            </div>
                        </div>

                        {workperformedby === "contractor" && (
                            <div className={`filter-chip ${contractorId !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                <div className="filter-chip-content">


                                    <ContractorModern contractorId={contractorId} project={project}
                                        subcompany={toggleCompany}
                                        setcontractorId={setcontractorId} cssType="modern" />

                                </div>
                            </div>
                        )}

                        <div className="filter-chip" style={{ paddingTop: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                {status === "pending" ? (
                                    <DateRangePicker
                                        startDate={fromdate}
                                        endDate={todate}
                                        placeHolder1="From Date"
                                        placeHolder2="To Date"
                                        onChange={(start, end) => {
                                            setFromDate(start);
                                            setToDate(end);
                                        }}
                                    />
                                ) : (
                                    <DateRangePicker
                                        startDate={approvefromdate}
                                        endDate={approvetodate}
                                        placeHolder1="From Date"
                                        placeHolder2="To Date"
                                        onChange={(start, end) => {
                                            setFromDate(start);
                                            setToDate(end);
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setToggleCompany("null");
                                    setProject("null");
                                    setcontractorId("null");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <BarChart3 size={14} />
                        <span>Showing</span>
                        <strong>{eotData.length} records</strong>
                    </div>
                </div>
                <div className="filter-bar-top" style={{ width: "20%", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive">
                        <DownloadSiteProject progressdata={eotData} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '15%' }}>PR No & Project</th>
                                <th className="col-period" style={{ width: '12%' }}>EOT Code</th>
                                <th className="col-period text-center">Contractor/Letters</th>
                                <th className="col-submitted text-center" style={{ width: '10%' }}>No. of Days</th>
                                <th className="col-approved text-center" style={{ width: '15%' }}>
                                    {status === "pending" ? "Initiated Date" : "Approval Date"}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {eotData.map((item, index) => {
                                const isExpanded = expandedRow === index;

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                {item.project_code} & {item.project_short_name}
                                            </td>
                                            <td className="col-period">{item.eot_code}</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Users size={12} />
                                                    <span>{item.contractor_name || "-"}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value">{item.approved_days || item.days}</span>
                                            </td>
                                            <td className="col-approved text-center">
                                                {status === "pending"
                                                    ? (item.process_initiate_date ? formatDate(item.process_initiate_date) : "-")
                                                    : (item.approved_date ? formatDate(item.approved_date) : "-")}
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={6}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Letter Details</span>
                                                            </div>
                                                        </div>

                                                        <div className="letters-section-attractive">
                                                            <div className={`letter-card-attractive ${(status === "pending" ? item.letter : item.close_letter) ? 'has-letter' : ''}`}>
                                                                <div className="letter-card-glow submitted-glow" />
                                                                <div className="letter-header-attractive">
                                                                    <div className="letter-icon-wrap submitted">
                                                                        <FileText size={15} />
                                                                    </div>
                                                                    <div className="letter-header-text">
                                                                        <span className="letter-title">
                                                                            {status === "pending" ? "EOT Letter" : "Closure Letter"}
                                                                        </span>
                                                                        <span className="letter-subtitle">
                                                                            {status === "pending" ? "Initiation document" : "Approval document"}
                                                                        </span>
                                                                    </div>
                                                                    <div className={`letter-status-dot ${(status === "pending" ? item.letter : item.close_letter) ? 'active' : 'inactive'}`} />
                                                                </div>
                                                                <div className="letter-body-attractive">
                                                                    {(status === "pending" ? item.letter : item.close_letter) ? (
                                                                        <ViewLetterModal i={status === "pending" ? item.letter : item.close_letter} usedFor="nestedTable" />
                                                                    ) : (
                                                                        <div className="no-letter-attractive">
                                                                            <FileX size={16} />
                                                                            <span>No letter attached</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {eotData.length === 0 && (
                                <tr>
                                    <td colSpan={6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <ClipboardX size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No EOT Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or switch the status to view more records.
                                            </p>
                                            {(toggleCompany !== "null" || project !== "null" || contractorId !== "null") && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setToggleCompany("null");
                                                        setProject("null");
                                                        setcontractorId("null");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const COSDetails = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [cosData, setcosData] = useState([]);
    const [buffer, setbuffer] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [error, setError] = useState(null);
    const [status, setStatus] = useState('pending');

    const [project, setProject] = useState("null");
    const [contractorId, setcontractorId] = useState("null");
    const [toggleCompany, setToggleCompany] = useState("null");
    const [workperformedby, setWorkperformedby] = useState("consultant");
    const [expandedRow, setExpandedRow] = useState(null);

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [approvefromdate, setApproveFromDate] = useState("null");
    const [approvetodate, setApproveToDate] = useState("null");

    const fetchCOSData = async () => {
        setbuffer(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/cosfilter/${project}/${workperformedby}/${contractorId}/${status}/${fromdate}/${todate}/${approvefromdate}/${approvetodate}/`);
            setcosData(response.data);
        } catch (err) {
            setError('Failed to fetch COS data');
        } finally {
            setbuffer(false);
        }
    };

    useEffect(() => {
        if (workperformedby === "consultant" || status === "pending") {
            setApproveFromDate("null");
            setApproveToDate("null");
            setcontractorId("null");
        }
        if (status === "Approved") {
            setFromDate("null");
            setToDate("null");
        } else {
            setFromDate("null");
            setToDate("null");
        }
    }, [workperformedby, status]);

    useEffect(() => {
        fetchCOSData();
    }, [project, status, contractorId, fromdate, todate, approvefromdate, approvetodate, workperformedby]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const hasActiveFilters = toggleCompany !== "null" || project !== "null" || contractorId !== "null";

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                            </div>
                        </div>

                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-icon"><Clock size={13} /></div>
                            <div className="filter-chip-content">
                                <span className="filter-chip-label">Status</span>
                                <select
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    className="modern-select"
                                >
                                    <option value="pending">Pending</option>
                                    <option value="Approved">Approved</option>
                                </select>
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-icon"><Users size={13} /></div>
                            <div className="filter-chip-content">
                                <span className="filter-chip-label">Related To</span>
                                <select
                                    value={workperformedby}
                                    onChange={(e) => setWorkperformedby(e.target.value)}
                                    className="modern-select"
                                >
                                    <option value="consultant">Consultant</option>
                                    <option value="contractor">Contractor</option>
                                </select>
                            </div>
                        </div>

                        {workperformedby === "contractor" && (
                            <div className={`filter-chip ${contractorId !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                                <div className="filter-chip-content">
                                    <ContractorModern contractorId={contractorId} project={project}
                                        subcompany={toggleCompany}
                                        setcontractorId={setcontractorId} cssType="modern" />
                                </div>
                            </div>
                        )}

                        <div className="filter-chip" style={{ paddingTop: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                {status === "pending" ? (
                                    <DateRangePicker
                                        startDate={fromdate}
                                        endDate={todate}
                                        placeHolder1="From Date"
                                        placeHolder2="To Date"
                                        onChange={(start, end) => {
                                            setFromDate(start);
                                            setToDate(end);
                                        }}
                                    />
                                ) : (
                                    <DateRangePicker
                                        startDate={approvefromdate}
                                        endDate={approvetodate}
                                        placeHolder1="From Date"
                                        placeHolder2="To Date"
                                        onChange={(start, end) => {
                                            setApproveFromDate(start);
                                            setApproveToDate(end);
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setToggleCompany("null");
                                    setProject("null");
                                    setcontractorId("null");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <BarChart3 size={14} />
                        <span>Showing</span>
                        <strong>{cosData.length} records</strong>
                    </div>
                </div>
                <div className="filter-bar-top" style={{ width: "20%", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive">
                        <DownloadSiteProject progressdata={cosData} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '15%' }}>PR No & Project</th>
                                <th className="col-period" style={{ width: '12%' }}>COS Code</th>
                                <th className="col-period text-center">Contractor/Letters</th>
                                <th className="col-submitted text-center" style={{ width: '12%' }}>Amount</th>
                                <th className="col-approved text-center" style={{ width: '15%' }}>
                                    {status === "pending" ? "Initiated Date" : "Approval Date"}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {cosData.map((item, index) => {
                                const isExpanded = expandedRow === index;

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                {item.project_code} & {item.project_short_name}
                                            </td>
                                            <td className="col-period">{item.cos_code}</td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Users size={12} />
                                                    <span>{item.contractor_name || "-"}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                            </td>
                                            <td className="col-submitted text-center">
                                                <span className="badge-value">₹{item.amount ? formatCurrencyIndian(item.amount) : "-"}</span>
                                            </td>
                                            <td className="col-approved text-center">
                                                {status === "pending"
                                                    ? (item.process_initiate_date ? formatDate(item.process_initiate_date) : "-")
                                                    : (item.approval_date ? formatDate(item.approval_date) : "-")}
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={6}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Letter Details</span>
                                                            </div>
                                                        </div>

                                                        <div className="letters-section-attractive">
                                                            <div className={`letter-card-attractive ${(status === "pending" ? item.letter : item.close_letter) ? 'has-letter' : ''}`}>
                                                                <div className="letter-card-glow submitted-glow" />
                                                                <div className="letter-header-attractive">
                                                                    <div className="letter-icon-wrap submitted">
                                                                        <FileText size={15} />
                                                                    </div>
                                                                    <div className="letter-header-text">
                                                                        <span className="letter-title">
                                                                            {status === "pending" ? "COS Letter" : "Closure Letter"}
                                                                        </span>
                                                                        <span className="letter-subtitle">
                                                                            {status === "pending" ? "Initiation document" : "Approval document"}
                                                                        </span>
                                                                    </div>
                                                                    <div className={`letter-status-dot ${(status === "pending" ? item.letter : item.close_letter) ? 'active' : 'inactive'}`} />
                                                                </div>
                                                                <div className="letter-body-attractive">
                                                                    {(status === "pending" ? item.letter : item.close_letter) ? (
                                                                        <ViewLetterModal i={status === "pending" ? item.letter : item.close_letter} usedFor="nestedTable" />
                                                                    ) : (
                                                                        <div className="no-letter-attractive">
                                                                            <FileX size={16} />
                                                                            <span>No letter attached</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {cosData.length === 0 && (
                                <tr>
                                    <td colSpan={6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Receipt size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No COS Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or switch the status to view more records.
                                            </p>
                                            {hasActiveFilters && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setToggleCompany("null");
                                                        setProject("null");
                                                        setcontractorId("null");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const MilestoneDetails = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [buffer, setBuffering] = useState(false);
    const [loading, setLoading] = useState(false);
    const role = sessionStorage.getItem('sitemanagement_role');
    const [project, setProject] = useState("null");
    const [subcompany, setSubCompany] = useState("null");
    const [milestoneList, setMilestoneList] = useState([]);
    const [actualFromDate, setActualFromDate] = useState("null");
    const [actualToDate, setActualToDate] = useState("null");
    const [rescheduleFromDate, setRescheduleFromDate] = useState("null");
    const [rescheduleToDate, setRescheduleToDate] = useState("null");
    const [contractor, setContractor] = useState("null");
    const [expandedRow, setExpandedRow] = useState(null);
    const [activeStatFilter, setActiveStatFilter] = useState('all'); // 'all' | 'achieved' | 'toBeAchieved' | 'skipped'

    const getMilestone = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/milestonefilterss/${project}/${contractor}/${rescheduleFromDate}/${rescheduleToDate}/${actualFromDate}/${actualToDate}/`);
            let filteredData = response.data;
            const filter = filteredData.filter(item => item.contractor !== null);
            setMilestoneList(filter);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getMilestone();
    }, [project, contractor, rescheduleFromDate, rescheduleToDate, actualFromDate, actualToDate]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const hasActiveFilters = project !== "null" || contractor !== "null";

    const getEffectiveDeadline = (days, rescheduleGapDays, gracePeriod) => {
        const baseDays = (rescheduleGapDays !== null && rescheduleGapDays !== undefined && rescheduleGapDays !== "")
            ? rescheduleGapDays
            : days;
        const gracePeriodd = gracePeriod || 0;
        const totalDays = Number(baseDays) + Number(gracePeriodd);
        return (totalDays)
    };

    const getStatusColor = (milestoneDay, actualDate, rescheduleGapDays, gracePeriod, actualDays) => {
        if (!actualDate) return 'pending';
        const effectiveDeadline = getEffectiveDeadline(milestoneDay, rescheduleGapDays, gracePeriod);
        if (!effectiveDeadline) return 'pending';
        return (actualDays) <= effectiveDeadline ? 'approved' : 'delayed';
    };

    const getStatusText = (milestoneDay, actualDate, rescheduleGapDays, gracePeriod, actualDays) => {
        if (!actualDate) return 'To Be Achieved';
        const effectiveDeadline = getEffectiveDeadline(milestoneDay, rescheduleGapDays, gracePeriod);
        if (!effectiveDeadline) return 'To Be Achieved';
        return (actualDays) <= effectiveDeadline ? 'Achieved' : 'Skipped';
    };

    const getDaysStatusClass = (days) => {
        if (!days || days === "-") return '';
        if (days < 0) return 'negative';
        if (days === 0) return 'zero';
        return 'positive';
    };

    // Classify every item once
    const classifiedList = milestoneList.map(m => {
        if (!m.milestone_as_per_actual) {
            return { ...m, _category: m.milestone_date ? 'toBeAchieved' : 'none' };
        }
        const deadline = getEffectiveDeadline(m.day, m.rescedule_gap_days ?? null, m.contractor_grace_period);
        const category = deadline && Number(m.actual_gap_days) <= Number(deadline) ? 'achieved' : 'skipped';
        return { ...m, _category: category };
    });

    const achievedCount = classifiedList.filter(m => m._category === 'achieved').length;
    const toBeAchievedCount = classifiedList.filter(m => m._category === 'toBeAchieved').length;
    const skippedCount = classifiedList.filter(m => m._category === 'skipped').length;

    // Apply the toggle filter for what's actually shown in the table
    const displayList = activeStatFilter === 'all'
        ? classifiedList
        : classifiedList.filter(m => m._category === activeStatFilter);

    const handleStatClick = (filterKey) => {
        setActiveStatFilter(prev => prev === filterKey ? 'all' : filterKey);
    };

    return (
        <div className="progress-modern-container">

            {role !== "SiteManagement" && showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={subcompany} />
                            </div>
                        </div>

                        <div className={`filter-chip ${contractor !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <ContractorModern contractorId={contractor} project={project} subcompany="null" setcontractorId={setContractor} cssType="modern" />
                            </div>
                        </div>

                        <div className="filter-chip" style={{ paddingTop: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                <DateRangePicker
                                    placeHolder1="From Actual"
                                    placeHolder2="To Actual"
                                    startDate={actualFromDate}
                                    endDate={actualToDate}
                                    onChange={(start, end) => {
                                        setActualFromDate(start);
                                        setActualToDate(end);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="filter-chip" style={{ paddingTop: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                <DateRangePicker
                                    placeHolder1="From Reschedule"
                                    placeHolder2="To Reschedule"
                                    startDate={rescheduleFromDate}
                                    endDate={rescheduleToDate}
                                    onChange={(start, end) => {
                                        setRescheduleFromDate(start);
                                        setRescheduleToDate(end);
                                    }}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setProject("null");
                                    setContractor("null");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary - now clickable toggles */}
            <div className="stats-minimal-row" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'all' ? 'stat-active' : ''}`}
                        onClick={() => setActiveStatFilter('all')}
                    >
                        <Flag size={14} />
                        <span>Total Milestones</span>
                        <strong>{milestoneList.length}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'achieved' ? 'stat-active achieved' : ''}`}
                        onClick={() => handleStatClick('achieved')}
                    >
                        <CheckCircle size={14} />
                        <span>Achieved</span>
                        <strong>{achievedCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'toBeAchieved' ? 'stat-active pending' : ''}`}
                        onClick={() => handleStatClick('toBeAchieved')}
                    >
                        <Clock size={14} />
                        <span>To be Achieved</span>
                        <strong>{toBeAchievedCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'skipped' ? 'stat-active skipped' : ''}`}
                        onClick={() => handleStatClick('skipped')}
                    >
                        <Cross size={14} />
                        <span>Skipped</span>
                        <strong>{skippedCount}</strong>
                    </div>
                </div>

                {role !== "SiteManagement" && (
                    <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                        <button
                            className="toggle-filters-btn"
                            onClick={() => setShowFilters(!showFilters)}
                        >
                            <Filter size={14} />
                            <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                            {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                        </button>

                        <div className="filter-actions-attractive">
                            <DownloadSiteProject progressdata={displayList} />
                        </div>
                    </div>
                )}
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead>
                            <tr>
                                <th className="col-sno">#</th>
                                <th className="col-milestone-name">Project / Milestone</th>
                                <th className="col-dates text-center">Dates</th>
                                <th className="col-days text-center">Days</th>
                                <th className="col-status text-center">Status</th>
                                <th className="col-letters text-center">Percentage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList
                                .sort((a, b) => new Date(a.milestone_date) - new Date(b.milestone_date))
                                .map((item, index) => {
                                    const isExpanded = expandedRow === index;
                                    const status = getStatusText(
                                        item.day || 0,
                                        item.milestone_as_per_actual,
                                        item.rescedule_gap_days ?? 0,
                                        item.contractor_grace_period || 0,
                                        item.actual_gap_days
                                    );
                                    const statusType = getStatusColor(
                                        item.day,
                                        item.milestone_as_per_actual,
                                        item.rescedule_gap_days ?? 0,
                                        item.contractor_grace_period || 0,
                                        item.actual_gap_days
                                    );
                                    const hasDelay = statusType === 'delayed';
                                    const acheived = statusType === 'approved';

                                    return (
                                        <React.Fragment key={index}>
                                            <tr className={`progress-row ${hasDelay ? 'has-pending' : ''} ${acheived ? 'has-achieved' : ''}`}>
                                                <td className="col-sno text-start">{index + 1}</td>
                                                <td className="col-milestone-name">
                                                    <button className="period-trigger" onClick={() => toggleRow(index)}>
                                                        <Flag size={12} />
                                                        <span>{item.site_prcode} • {item.name || "-"}</span>
                                                        {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                    </button>
                                                    <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                        {item.project_name} • {item.contractor_name || "-"}
                                                    </div>
                                                </td>
                                                <td className="col-dates">
                                                    <div className="dates-container">
                                                        <div className="date-item">
                                                            <span className="date-label">Milestone:</span>
                                                            <span className="date-value">
                                                                {item.milestone_date ? formattedDateLong(item.milestone_date) : '-'}
                                                            </span>
                                                        </div>
                                                        <div className="date-item">
                                                            <span className="date-label">Reschedule:</span>
                                                            <span className="date-value">
                                                                {item.milestone_as_per_reschedule ? formattedDateLong(item.milestone_as_per_reschedule) : '-'}
                                                            </span>
                                                        </div>
                                                        <div className="day-item">
                                                            <span className="day-label">Deadline</span>
                                                            <span className="day-value">
                                                                {(() => {
                                                                    const gracePeriod = item.contractor_grace_period || 0;
                                                                    const baseDate = item.milestone_as_per_reschedule
                                                                        ? new Date(item.milestone_as_per_reschedule)
                                                                        : item.milestone_date
                                                                            ? new Date(item.milestone_date)
                                                                            : null;
                                                                    if (!baseDate || isNaN(baseDate.getTime())) return '-';
                                                                    const newDate = new Date(baseDate.getTime() + gracePeriod * 24 * 60 * 60 * 1000);
                                                                    return newDate.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
                                                                })()}
                                                            </span>
                                                        </div>
                                                        <div className="date-item">
                                                            <span className="date-label">Actual:</span>
                                                            <span className={`date-value ${item.milestone_as_per_actual ? 'has-value' : ''}`}>
                                                                {item.milestone_as_per_actual ? formattedDateLong(item.milestone_as_per_actual) : '-'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="col-days">
                                                    <div className="days-container">
                                                        <div className="day-item">
                                                            <span className="day-label">Milestone:</span>
                                                            <span className={`day-value ${getDaysStatusClass(item.day)}`}>
                                                                {item.day ? `${item.day} days` : '-'}
                                                            </span>
                                                        </div>
                                                        <div className="day-item">
                                                            <span className="day-label">Reschedule:</span>
                                                            <span className={`day-value ${getDaysStatusClass(item.rescedule_gap_days)}`}>
                                                                {item.rescedule_gap_days ? `${item.rescedule_gap_days} days` : '-'}
                                                            </span>
                                                        </div>
                                                        <div className="day-item">
                                                            <span className="day-label">Grace Period:</span>
                                                            <span className="day-value">
                                                                {item.contractor_grace_period ? `${item.contractor_grace_period} days` : '-'}
                                                            </span>
                                                        </div>
                                                        <div className="day-item">
                                                            <span className="day-label">Actual:</span>
                                                            <span className={`day-value ${getDaysStatusClass(item.actual_gap_days)}`}>
                                                                {item.actual_gap_days ? `${item.actual_gap_days} days` : '-'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="col-status text-center">
                                                    <span className={`status-badge-minimal ${statusType === 'approved' ? 'approved' : statusType === 'delayed' ? 'pending' : 'warning'}`}>
                                                        {status}
                                                    </span>
                                                </td>
                                                <td className="col-status text-center">
                                                    <span className={`status-badge-minimal ${statusType === 'approved' ? 'approved' : statusType === 'delayed' ? 'pending' : 'warning'}`}>
                                                        {item.milestone_percentage || '-'}
                                                    </span>
                                                </td>
                                            </tr>

                                            {isExpanded && (
                                                <tr className="expanded-row">
                                                    <td colSpan={6}>
                                                        <div className="expanded-content-attractive">
                                                            <div className="expanded-content-header">
                                                                <div className="expanded-content-title">
                                                                    <Sparkles size={13} />
                                                                    <span>Letter Details</span>
                                                                </div>
                                                            </div>

                                                            <div className="letters-section-attractive">
                                                                <div className={`letter-card-attractive ${item.actual_letter ? 'has-letter' : ''}`}>
                                                                    <div className="letter-card-glow submitted-glow" />
                                                                    <div className="letter-header-attractive">
                                                                        <div className="letter-icon-wrap submitted">
                                                                            <CalendarCheck size={15} />
                                                                        </div>
                                                                        <div className="letter-header-text">
                                                                            <span className="letter-title">Actual Achievement Letter</span>
                                                                            <span className="letter-subtitle">
                                                                                {item.actual_gap_days ? `${item.actual_gap_days} gap days` : "No gap recorded"}
                                                                            </span>
                                                                        </div>
                                                                        <div className={`letter-status-dot ${item.actual_letter ? 'active' : 'inactive'}`} />
                                                                    </div>
                                                                    <div className="letter-body-attractive">
                                                                        {item.actual_letter ? (
                                                                            <AllAssociatedLetters
                                                                                id={item.actual_letter}
                                                                                project={item.project}
                                                                                workperformedby={item.workperformedby}
                                                                                lettertype="Milestone"
                                                                                buttonUI="normal"
                                                                            />
                                                                        ) : (
                                                                            <div className="no-letter-attractive">
                                                                                <FileX size={16} />
                                                                                <span>No letter attached</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="letter-connector">
                                                                    <ArrowRight size={14} />
                                                                </div>

                                                                <div className={`letter-card-attractive ${item.reschedule_letter ? 'has-letter' : ''}`}>
                                                                    <div className="letter-card-glow approved-glow" />
                                                                    <div className="letter-header-attractive">
                                                                        <div className="letter-icon-wrap approved">
                                                                            <CalendarClock size={15} />
                                                                        </div>
                                                                        <div className="letter-header-text">
                                                                            <span className="letter-title">Reschedule Letter</span>
                                                                            <span className="letter-subtitle">
                                                                                {item.milestone_as_per_reschedule ? item.milestone_as_per_reschedule : "No date recorded"}
                                                                            </span>
                                                                        </div>
                                                                        <div className={`letter-status-dot ${item.reschedule_letter ? 'active' : 'inactive'}`} />
                                                                    </div>
                                                                    <div className="letter-body-attractive">
                                                                        {item.reschedule_letter ? (
                                                                            <AllAssociatedLetters
                                                                                id={item.reschedule_letter}
                                                                                project={item.project}
                                                                                workperformedby={item.workperformedby}
                                                                                lettertype="Milestone"
                                                                                buttonUI="normal"
                                                                            />
                                                                        ) : (
                                                                            <div className="no-letter-attractive">
                                                                                <FileX size={16} />
                                                                                <span>No letter attached</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            {displayList.length === 0 && (
                                <tr>
                                    <td colSpan={6}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Milestone size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Milestone Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                {activeStatFilter !== 'all'
                                                    ? "No records match this status. Try a different filter."
                                                    : "Try adjusting your filters or select a different project to view records."}
                                            </p>
                                            {(hasActiveFilters || activeStatFilter !== 'all') && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setProject("null");
                                                        setContractor("null");
                                                        setActiveStatFilter("all");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

// const BillingDetailsProgress = () => {
//     const [buffer, setBuffering] = useState(false); // Buffering logic
//     const role = sessionStorage.getItem('sitemanagement_role');



//     const [project, setProject] = useState("null");

//     const [contractorId, setcontractorId] = useState("null");
//     const [contractorlist, setContractorList] = useState([]);
//     const [toggleCompany, setToggleCompany] = useState("null");
//     const [fromstartDate, setfromstartDate] = useState("null");
//     const [toStartDate, settoStartDate] = useState("null");
//     const [fromEndDate, setfromEndDate] = useState("null");
//     const [toEndDate, settoEndDate] = useState("null");

//     const [error, setError] = useState(null);
//     const [billingData, setBillingData] = useState([]);
//     const [approvefromdate, setApproveFromDate] = useState("null");
//     const [approvetodate, setApproveToDate] = useState("null");
//     const [workperformedby, setWorkperformedby] = useState("consultant");
//     const [status, setStatus] = useState('pending');
//     const [fromdate, setFromDate] = useState("null");
//     const [todate, setToDate] = useState("null");



//     const fetchbillingData = async () => {
//         setBuffering(true);
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/billingfilterss/${project}/${contractorId}/${fromstartDate}/${toStartDate}/${fromEndDate}/${toEndDate}/`);
//             setBillingData(response.data);
//         } catch (err) {
//             setError("Failed to fetch billing data");
//         } finally {
//             setBuffering(false);
//         }
//     };

//     const getContractor = async () => {
//         // setbuffer(true);
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${project}/null/`);
//             setContractorList(res.data)
//         } catch (error) {
//             console.error(error);

//         } finally {
//             // setbuffer(false);
//         }
//     };

//     useEffect(() => {
//         if (workperformedby === "contractor") {
//             getContractor();
//         };
//     }, [project, workperformedby]);

//     useEffect(() => {
//         if (workperformedby === "consultant" || status === "pending") {
//             setApproveFromDate("null");
//             setApproveToDate("null");
//             setcontractorId("null");
//         }
//         if (status === "Approved") {
//             setFromDate("null");
//             setToDate("null");
//         }

//         else {
//             setFromDate("null");
//             setToDate("null");
//         }

//         fetchbillingData();
//     }, [project, contractorId, fromstartDate, toStartDate, fromEndDate, toEndDate]);


//     return (
//         <>


//             <div className="attendance-subcontainer margin">
//                 <div className="field-cont  justify-between">
//                     <div className="field-cont ">

//                         <SubCompany toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} />

//                         <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />


//                         <div title="Company Filter" className="field-cont-div">
//                             <CircularGrid />
//                             <select
//                                 onChange={(e) => setcontractorId(e.target.value)}
//                                 value={contractorId}
//                                 style={{ cursor: 'pointer' }}
//                                 className="attendance-input-field width-15vw date-field"
//                             >
//                                 <option value="null">Contractor Name</option>
//                                 {contractorlist?.map((i) => (
//                                     <option key={i.id} value={i.id}>{i.name}</option>
//                                 ))}
//                             </select>
//                             <hr className="field-cont-hr" />
//                         </div>



//                     </div>

//                     <div>
//                         <DownloadSiteProject progressdata={billingData} />
//                     </div>
//                 </div>
//             </div>
//             <div className="info-box-div-bg">


//                 <div className="table-css-white-background form-flex-wrap table-box paddingTop-0px scroll-container-table child-table-scroll" style={{ minHeight: "450px" }}>
//                     <table className='custom-table' style={{ minHeight: "311px" }}>
//                         <thead className='heading'>
//                             <tr className='custom-table-head-tr global-table-tr'>
//                                 <th className='table-heading-text text-left'>S no.</th>
//                                 <th className='table-heading-text text-left'>PR NO & Project Name</th>
//                                 <th className='table-heading-text text-left'>Contractor Name</th>
//                                 <th className='table-heading-text text-left'>Bill Details</th>
//                                 <th className='table-heading-text text-left'>Submitted</th>
//                                 <th className='table-heading-text text-left'>Recommended</th>
//                                 <th className='table-heading-text text-left'>Other Amount</th>

//                             </tr>
//                         </thead>
//                         {buffer ? (
//                             <div className="spinner-bgdatil"></div>
//                         ) : (
//                             <tbody>
//                                 {billingData.map((project, index) => (
//                                     <React.Fragment key={index}>
//                                         <tr className="tr-border-bottom">
//                                             <td colSpan="8"></td>
//                                         </tr>
//                                         <tr className='custom-table-head-td global-table-td'>
//                                             <td className='table-body text-left-sr'>{index + 1}.</td>
//                                             <td className='table-body text-left'><div className='whitespace-normal'>{project.project_code} <br /> {project.project_short_name} </div>

//                                             </td>
//                                             <td className='table-body text-left'><div className='whitespace-normal'>{project.contractors_names ? project.contractors_names : <p className=''>-</p>}</div></td>

//                                             <td className='table-body' >
//                                                 <div >
//                                                     <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                         <tbody>
//                                                             <tr>

//                                                                 <td className="align-right table-body text-left">
//                                                                     <div className='whitespace-normal'>
//                                                                         {project?.bill_num
//                                                                             ? project?.bill_num
//                                                                             : "-"}, {" "} {project?.bill_type
//                                                                                 ? project?.bill_type
//                                                                                 : "-"},{" "}  {project?.bill_catagory
//                                                                                     ? project?.bill_catagory === "balancebills" ? "Bal Bill" : project?.bill_catagory
//                                                                                     : "-"}
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>

//                                                             <tr>
//                                                                 {/* <td className="padding-bottom-5px table-body">Start date</td> */}
//                                                                 {/* <td className='table-body' style={{ padding: "0px 4px" }}>:</td> */}
//                                                                 <td className="table-body text-left">
//                                                                     {project?.bill_period_start
//                                                                         ? formatDate(project?.bill_period_start)
//                                                                         : "-"}
//                                                                 </td>
//                                                             </tr>
//                                                             <tr>
//                                                                 {/* <td className="padding-bottom-5px table-body">End date</td> */}
//                                                                 {/* <td className='table-body' style={{ padding: "0px 4px" }}>:</td> */}
//                                                                 <td className="table-body text-left">
//                                                                     {project?.bill_period_end
//                                                                         ? formatDate(project?.bill_period_end)
//                                                                         : "-"}
//                                                                 </td>
//                                                             </tr>
//                                                         </tbody>
//                                                     </table>
//                                                 </div>
//                                             </td>
//                                             <td className='table-body'>
//                                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Date</td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="text-end table-body">
//                                                                 {project?.submitted_bill_date
//                                                                     ? formatDate(project?.submitted_bill_date)
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Amount</td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="table-body text-end" >
//                                                                 {project?.submitted_bill_amount
//                                                                     ? `₹ ${formatRoundoffCrores(project?.submitted_bill_amount)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </table>
//                                             </td>
//                                             <td className='table-body'>
//                                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Date</td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="text-end table-body">
//                                                                 {project?.recomended_bill_date
//                                                                     ? formatDate(project?.recomended_bill_date)
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Amount</td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="table-body text-end" >
//                                                                 {project?.recommended_bill_amount
//                                                                     ? `₹ ${formatRoundoffCrores(project?.recommended_bill_amount)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </table>
//                                             </td>
//                                             <td className='table-body'>
//                                                 <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Ld </td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="text-end table-body">
//                                                                 {project?.ld_amount
//                                                                     ? `₹ ${formatRoundoffCrores(project?.ld_amount)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Withheld</td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="table-body text-end">
//                                                                 {project?.withheld_amt
//                                                                     ? `₹ ${formatRoundoffCrores(project?.withheld_amt)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Deduction </td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="table-body text-end">
//                                                                 {project?.deduction_amount
//                                                                     ? `₹ ${formatRoundoffCrores(project?.deduction_amount)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="padding-bottom-5px table-body text-left">Released Withheld </td>
//                                                             <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
//                                                             <td className="table-body text-end">
//                                                                 {project?.released_withheld_amt
//                                                                     ? `₹ ${formatRoundoffCrores(project?.released_withheld_amt)}`
//                                                                     : "-"}
//                                                             </td>
//                                                         </tr>

//                                                     </tbody>
//                                                 </table>
//                                             </td>
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}
//                             </tbody>
//                         )}
//                     </table>
//                 </div>

//             </div>
//         </>
//     );
// };


const BillingDetailsProgress = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [buffer, setBuffering] = useState(false);
    const role = sessionStorage.getItem('sitemanagement_role');

    const [project, setProject] = useState("null");
    const [contractorId, setcontractorId] = useState("null");
    const [contractorlist, setContractorList] = useState([]);
    const [toggleCompany, setToggleCompany] = useState("null");
    const [fromstartDate, setfromstartDate] = useState("null");
    const [toStartDate, settoStartDate] = useState("null");
    const [fromEndDate, setfromEndDate] = useState("null");
    const [toEndDate, settoEndDate] = useState("null");
    const [expandedRow, setExpandedRow] = useState(null);

    const [error, setError] = useState(null);
    const [billingData, setBillingData] = useState([]);
    const [workperformedby, setWorkperformedby] = useState("consultant");

    const fetchbillingData = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/billingfilterss/${project}/${contractorId}/${fromstartDate}/${toStartDate}/${fromEndDate}/${toEndDate}/`);
            setBillingData(response.data);
        } catch (err) {
            setError("Failed to fetch billing data");
        } finally {
            setBuffering(false);
        }
    };

    const getContractor = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${project}/null/`);
            setContractorList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (workperformedby === "contractor") {
            getContractor();
        }
    }, [project, workperformedby]);

    useEffect(() => {
        fetchbillingData();
    }, [project, contractorId, fromstartDate, toStartDate, fromEndDate, toEndDate]);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const hasActiveFilters = toggleCompany !== "null" || project !== "null" || contractorId !== "null";

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                            </div>
                        </div>

                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                            </div>
                        </div>

                        <div className={`filter-chip ${contractorId !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <ContractorModern contractorId={contractorId} contractorlist={contractorlist} project={project} setcontractorId={setcontractorId} cssType="modern" />
                            </div>
                        </div>

                        <div className="filter-chip" style={{ padding: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                <DateRangePicker
                                    placeHolder1="Start From"
                                    placeHolder2="Start To"
                                    startDate={fromstartDate}
                                    endDate={toStartDate}
                                    onChange={(start, end) => {
                                        setfromstartDate(start);
                                        settoStartDate(end);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="filter-chip" style={{ padding: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                <DateRangePicker
                                    placeHolder1="End From"
                                    placeHolder2="End To"
                                    startDate={fromEndDate}
                                    endDate={toEndDate}
                                    onChange={(start, end) => {
                                        setfromEndDate(start);
                                        settoEndDate(end);
                                    }}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setToggleCompany("null");
                                    setProject("null");
                                    setcontractorId("null");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary */}
            <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="stats-minimal-row">
                    <div className="stat-minimal-item">
                        <BarChart3 size={14} />
                        <span>Showing</span>
                        <strong>{billingData.length} records</strong>
                    </div>
                </div>
                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive">
                        <DownloadSiteProject progressdata={billingData} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '18%' }}>PR No & Project</th>
                                <th className="col-period text-center">Contractor / Bill Details</th>
                                <th className="col-submitted text-center" style={{ width: '15%' }}>Submitted</th>
                                <th className="col-approved text-center" style={{ width: '15%' }}>Recommended</th>
                            </tr>
                        </thead>
                        <tbody>
                            {billingData.map((item, index) => {
                                const isExpanded = expandedRow === index;

                                return (
                                    <React.Fragment key={index}>
                                        <tr className="progress-row">
                                            <td className="col-sno text-start">{index + 1}.</td>
                                            <td className="col-period">
                                                {item.project_code} <br /> {item.project_short_name}
                                            </td>
                                            <td className="col-period">
                                                <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                                                    <Users size={12} />
                                                    <span>{item.contractors_names || "-"}</span>
                                                    {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                                                </button>
                                                <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                                                    {item.bill_num || "-"} • {item.bill_type || "-"} • {item.bill_catagory === "balancebills" ? "Bal Bill" : (item.bill_catagory || "-")}
                                                </div>
                                            </td>
                                            <td className="col-submitted">
                                                <div className="progress-badge">
                                                    <span className="badge-label">Date</span>
                                                    <span className="badge-value">
                                                        {item.submitted_bill_date ? formatDate(item.submitted_bill_date) : "-"}
                                                    </span>
                                                </div>
                                                <div className="progress-badge">
                                                    <span className="badge-label">Amount</span>
                                                    <span className="badge-value">
                                                        {item.submitted_bill_amount ? `₹${formatRoundoffCrores(item.submitted_bill_amount)}` : "-"}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="col-approved">
                                                <div className="progress-badge approved">
                                                    <span className="badge-label">Date</span>
                                                    <span className="badge-value">
                                                        {item.recomended_bill_date ? formatDate(item.recomended_bill_date) : "-"}
                                                    </span>
                                                </div>
                                                <div className="progress-badge approved">
                                                    <span className="badge-label">Amount</span>
                                                    <span className="badge-value">
                                                        {item.recommended_bill_amount ? `₹${formatRoundoffCrores(item.recommended_bill_amount)}` : "-"}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr className="expanded-row">
                                                <td colSpan={5}>
                                                    <div className="expanded-content-attractive">
                                                        <div className="expanded-content-header">
                                                            <div className="expanded-content-title">
                                                                <Sparkles size={13} />
                                                                <span>Bill Breakdown</span>
                                                            </div>
                                                        </div>

                                                        {/* Bill Period + Deductions row */}
                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '220px' }}>
                                                                <div className="stage-header">
                                                                    <Calendar size={14} />
                                                                    <span>Bill Period</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Start Date</span>
                                                                        <span className="amount">
                                                                            {item.bill_period_start ? formatDate(item.bill_period_start) : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">End Date</span>
                                                                        <span className="amount">
                                                                            {item.bill_period_end ? formatDate(item.bill_period_end) : "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '220px' }}>
                                                                <div className="stage-header">
                                                                    <Landmark size={14} />
                                                                    <span>Deductions</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">LD Amount</span>
                                                                        <span className="amount">
                                                                            {item.ld_amount ? `₹${formatCurrencyIndian(item.ld_amount)}` : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Deduction</span>
                                                                        <span className="amount">
                                                                            {item.deduction_amount ? `₹${formatCurrencyIndian(item.deduction_amount)}` : "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="stage-card approved" style={{ flex: 1, minWidth: '220px' }}>
                                                                <div className="stage-header">
                                                                    <Wallet size={14} />
                                                                    <span>Withheld Amounts</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Withheld</span>
                                                                        <span className="amount">
                                                                            {item.withheld_amt ? `₹${formatCurrencyIndian(item.withheld_amt)}` : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Released</span>
                                                                        <span className="amount">
                                                                            {item.released_withheld_amt ? `₹${formatCurrencyIndian(item.released_withheld_amt)}` : "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Submitted / AE-IE Recommended / Client Approved — same as BillTable */}
                                                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                                            <div className="stage-card submitted" style={{ flex: 1, minWidth: '250px' }}>
                                                                <div className="stage-header">
                                                                    <FileText size={12} />
                                                                    <span>Submitted</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Date:</span>
                                                                        <span>{item.submitted_bill_date ? formatDateDD_MM_YYYY(item.submitted_bill_date) : '-'}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Amount:</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(item.submitted_bill_amount || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Percentage:</span>
                                                                        <span>{item.submitted_percentage}%</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Per. Amount:</span>
                                                                        <span>₹{formatCurrencyIndian(item.percentage_amt || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Summary:</span>
                                                                        <ViewAmountModel modernCSS="true" usedIn="nestedTable" usedFor="ContractorBilling" i={item} bills={billingData} />
                                                                    </div>
                                                                    {item.submitted_letter_num && (
                                                                        <div className="stage-row">
                                                                            <span className="stage-label">Letter:</span>
                                                                            <ViewLetterModal modernCSS="true" i={item.submitted_letter_num} usedFor="nestedTable" />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="stage-card recommended" style={{ flex: 1, minWidth: '250px' }}>
                                                                <div className="stage-header">
                                                                    <CheckCircle size={12} />
                                                                    <span>AE/IE Recommended</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Date:</span>
                                                                        <span>{item.recomended_bill_date ? formatDateDD_MM_YYYY(item.recomended_bill_date) : '-'}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Amount:</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(item.recommended_bill_amount || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Percentage:</span>
                                                                        <span>{item.recommended_percentage}%</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Per. Amount:</span>
                                                                        <span>₹{formatCurrencyIndian(item.ho_percentage_amt || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Summary:</span>
                                                                        <ViewAmountModel modernCSS="true" usedIn="nestedTable" usedFor="HO" i={item} bills={billingData} />
                                                                    </div>
                                                                    {item.recomended_letter_num && (
                                                                        <div className="stage-row">
                                                                            <span className="stage-label">Letter:</span>
                                                                            <ViewLetterModal modernCSS="true" i={item.recomended_letter_num} usedFor="nestedTable" />
                                                                        </div>
                                                                    )}
                                                                    {item.ho_attachment && (
                                                                        <div className="stage-row">
                                                                            <span className="stage-label">Attachment:</span>
                                                                            <a href={item.ho_attachment} target="blank" className="attachment-link">View</a>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="stage-card approved" style={{ flex: 1, minWidth: '250px' }}>
                                                                <div className="stage-header">
                                                                    <Award size={12} />
                                                                    <span>Client Approved</span>
                                                                </div>
                                                                <div className="stage-content">
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Date:</span>
                                                                        <span>{item.site_recomended_bill_date ? formatDateDD_MM_YYYY(item.site_recomended_bill_date) : '-'}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Amount:</span>
                                                                        <span className="amount">₹{formatCurrencyIndian(item.site_recommended_bill_amount || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Percentage:</span>
                                                                        <span>{item.site_recommended_percentage}%</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Per. Amount:</span>
                                                                        <span>₹{formatCurrencyIndian(item.site_percentage_amt || 0)}</span>
                                                                    </div>
                                                                    <div className="stage-row">
                                                                        <span className="stage-label">Summary:</span>
                                                                        <ViewAmountModel modernCSS="true" usedIn="nestedTable" usedFor="SiteBilling" i={item} bills={billingData} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {billingData.length === 0 && (
                                <tr>
                                    <td colSpan={5}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <FileSpreadsheet size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Billing Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                Try adjusting your filters or select a different project to view records.
                                            </p>
                                            {hasActiveFilters && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setToggleCompany("null");
                                                        setProject("null");
                                                        setcontractorId("null");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};



const BGDetails = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [projectData, setProjectData] = useState([]);
    const [buffer, setbuffer] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [contractorlist, setContractorList] = useState([]);
    const [project, setProject] = useState("null");
    const [toggleCompany, setToggleCompany] = useState("null");
    const [workperformedby, setWorkperformedby] = useState("consultant");
    const [contractorId, setcontractorId] = useState("null");

    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [approvefromdate, setApproveFromDate] = useState("null");
    const [approvetodate, setApproveToDate] = useState("null");

    const [error, setError] = useState(null);
    const [status, setStatus] = useState('pending');
    const [activeStatFilter, setActiveStatFilter] = useState('all'); // 'all' | 'pending' | 'expired' | 'aboutToExpire'

    const fetchProjectData = async () => {
        setbuffer(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/bgfilter/${project}/null/null/null/null/`);
            setProjectData(response.data);
        } catch (err) {
            setError('Failed to fetch BG data');
        } finally {
            setbuffer(false);
        }
    };

    const getContractor = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${project}/null/`);
            setContractorList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (workperformedby === "contractor") {
            getContractor();
        }
    }, [project, workperformedby]);

    useEffect(() => {
        if (workperformedby === "consultant" || status === "pending") {
            setApproveFromDate("null");
            setApproveToDate("null");
            setcontractorId("null");
        }
        if (status === "Approved") {
            setFromDate("null");
            setToDate("null");
        } else {
            setFromDate("null");
            setToDate("null");
        }
    }, [workperformedby, status]);

    useEffect(() => {
        fetchProjectData();
    }, [project]);

    const today = new Date();

    // Classify every BG item
    const classifiedList = projectData.map(item => {
        const expiryDate = new Date(item.bg_expiry_date);
        const isExpired = expiryDate < today;
        const isPending = item.bg_remark === "Pending";
        let category = 'active';
        if (isPending) category = 'pending';
        else if (isExpired) category = 'expired';
        else category = 'aboutToExpire';
        return { ...item, _category: category, _isExpired: isExpired, _isPending: isPending };
    });

    const totalCount = projectData.length;
    const totalAmount = projectData.reduce((sum, item) => {
        const amt = parseInt(item.bg_amount);
        return sum + (isNaN(amt) ? 0 : amt);
    }, 0);
    const pendingCount = classifiedList.filter(m => m._category === 'pending').length;
    const expiredCount = classifiedList.filter(m => m._category === 'expired').length;
    const aboutToExpireCount = classifiedList.filter(m => m._category === 'aboutToExpire').length;

    const displayList = activeStatFilter === 'all'
        ? classifiedList
        : classifiedList.filter(m => m._category === activeStatFilter);

    const handleStatClick = (filterKey) => {
        setActiveStatFilter(prev => prev === filterKey ? 'all' : filterKey);
    };

    const hasActiveFilters = toggleCompany !== "null" || project !== "null" || contractorId !== "null";

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                            </div>
                        </div>

                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                            </div>
                        </div>





                        <div className="filter-chip" style={{ paddingTop: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
                            <div className="filter-chip-content">
                                {status === "pending" ? (
                                    <DateRangePicker
                                        startDate={fromdate}
                                        endDate={todate}
                                        placeHolder1="Start Date"
                                        placeHolder2="Expiry Date"
                                        onChange={(start, end) => {
                                            setFromDate(start);
                                            setToDate(end);
                                        }}
                                    />
                                ) : (
                                    <DateRangePicker
                                        startDate={approvefromdate}
                                        endDate={approvetodate}
                                        placeHolder1="From Date"
                                        placeHolder2="To Date"
                                        onChange={(start, end) => {
                                            setApproveFromDate(start);
                                            setApproveToDate(end);
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setToggleCompany("null");
                                    setProject("null");
                                    setcontractorId("null");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary - clickable toggles */}
            <div className="stats-minimal-row" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'all' ? 'stat-active' : ''}`}
                        onClick={() => setActiveStatFilter('all')}
                    >
                        <Landmark size={14} />
                        <span>Total BG</span>
                        <strong>{totalCount}</strong>
                    </div>
                    <div className="stat-minimal-item">
                        <IndianRupee size={14} />
                        <span>Total Amount</span>
                        <strong>₹{totalAmount.toLocaleString()}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'pending' ? 'stat-active pending' : ''}`}
                        onClick={() => handleStatClick('pending')}
                    >
                        <Clock size={14} />
                        <span>Pending</span>
                        <strong>{pendingCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'expired' ? 'stat-active skipped' : ''}`}
                        onClick={() => handleStatClick('expired')}
                    >
                        <AlertCircle size={14} />
                        <span>Expired</span>
                        <strong>{expiredCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'aboutToExpire' ? 'stat-active achieved' : ''}`}
                        onClick={() => handleStatClick('aboutToExpire')}
                    >
                        <CheckCircle size={14} />
                        <span>Active</span>
                        <strong>{aboutToExpireCount}</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive">
                        <DownloadSiteProject progressdata={displayList} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '18%' }}>PR No & Project</th>
                                <th className="col-period">Bank Details</th>
                                <th className="col-submitted text-center" style={{ width: '12%' }}>Amount</th>
                                <th className="col-approved text-center" style={{ width: '18%' }}>Validity</th>
                                <th className="col-status text-center" style={{ width: '10%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '8%' }}>Document</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList.map((item, index) => (
                                <tr key={index} className={`progress-row ${item._category === 'expired' ? 'has-pending' : ''} ${item._category === 'aboutToExpire' ? 'has-achieved' : ''}`}>
                                    <td className="col-sno text-start">{index + 1}.</td>
                                    <td className="col-period">
                                        {item.project ? `${item.site_pr_code} & ${item.site_project_short_name}` : "-"}
                                    </td>
                                    <td className="col-period">
                                        <div style={{ fontWeight: 600, fontSize: '12px' }}>{item.bank_name || "-"}</div>
                                        <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>BG No: {item.bg_num || "-"}</div>
                                    </td>
                                    <td className="col-submitted text-center">
                                        <span className="badge-value">₹{item.bg_amount ? Number(item.bg_amount).toLocaleString() : "-"}</span>
                                    </td>
                                    <td className="col-approved">
                                        <div className="progress-badge">
                                            <span className="badge-label">Start</span>
                                            <span className="badge-value">{item.bg_date ? formattedDateLong(item.bg_date) : "-"}</span>
                                        </div>
                                        <div className="progress-badge approved">
                                            <span className="badge-label">Expiry</span>
                                            <span className="badge-value">{item.bg_expiry_date ? formattedDateLong(item.bg_expiry_date) : "-"}</span>
                                        </div>
                                    </td>
                                    <td className="col-status text-center">
                                        <span className={`status-badge-minimal ${item._category === 'expired' ? 'pending' : item._category === 'pending' ? 'warning' : 'approved'}`}>
                                            {item._category === 'expired' ? 'Expired' : item._category === 'pending' ? 'Pending' : 'Active'}
                                        </span>
                                    </td>
                                    <td className="col-action text-center">
                                        {!item.bg_document ? (
                                            <span style={{ fontSize: '11px', color: '#cbd5e1', fontStyle: 'italic' }}>Not Attached</span>
                                        ) : (
                                            <a href={item.bg_document} target="blank" className="attachment-link">
                                                <FileCheck size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                                                View
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {displayList.length === 0 && (
                                <tr>
                                    <td colSpan={7}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <Landmark size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Bank Guarantee Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                {activeStatFilter !== 'all'
                                                    ? "No records match this status. Try a different filter."
                                                    : "Try adjusting your filters or select a different project to view records."}
                                            </p>
                                            {(hasActiveFilters || activeStatFilter !== 'all') && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setToggleCompany("null");
                                                        setProject("null");
                                                        setcontractorId("null");
                                                        setActiveStatFilter("all");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

const InsuranceDetails = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [insuranceData, setInsuranceData] = useState([]);
    const [buffer, setbuffer] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");

    const [project, setProject] = useState("null");
    const [toggleCompany, setToggleCompany] = useState("null");
    const [approveFromDate, setApproveFromDate] = useState("null");
    const [approveToDate, setApproveToDate] = useState("null");

    const [error, setError] = useState(null);
    const [activeStatFilter, setActiveStatFilter] = useState('all'); // 'all' | 'expired' | 'active'

    const fetchInsuranceData = async () => {
        setbuffer(true);
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/insurencefilter/${project}/null/null/null/null/`);
            setInsuranceData(response.data);
        } catch (err) {
            setError('Failed to fetch Insurance data');
        } finally {
            setbuffer(false);
        }
    };

    useEffect(() => {
        fetchInsuranceData();
    }, [project]);

    const today = new Date();

    // Classify every insurance item
    const classifiedList = insuranceData.map(item => {
        const expiryDate = new Date(item.insurance_policy_valid_upto_date);
        const isExpired = expiryDate < today;
        return { ...item, _category: isExpired ? 'expired' : 'active' };
    });

    const totalCount = insuranceData.length;
    const totalAmount = insuranceData.reduce((sum, item) => {
        const amt = parseInt(item.insurance_amount);
        return sum + (isNaN(amt) ? 0 : amt);
    }, 0);
    const expiredCount = classifiedList.filter(m => m._category === 'expired').length;
    const activeCount = classifiedList.filter(m => m._category === 'active').length;

    const displayList = activeStatFilter === 'all'
        ? classifiedList
        : classifiedList.filter(m => m._category === activeStatFilter);

    const handleStatClick = (filterKey) => {
        setActiveStatFilter(prev => prev === filterKey ? 'all' : filterKey);
    };

    const hasActiveFilters = toggleCompany !== "null" || project !== "null";

    return (
        <div className="progress-modern-container">

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive">
                        <div className={`filter-chip ${toggleCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                            <div className="filter-chip-content">
                                <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                            </div>
                        </div>

                        <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                            <div className="filter-chip-content">
                                <Projects usedFor="filter" value="id" toggleProject={project} setToggleProject={setProject} subcompany={toggleCompany} />
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-icon"><Calendar size={13} /></div>
                            <div className="filter-chip-content">
                                <span className="filter-chip-label">Start Date</span>
                                <input
                                    type="date"
                                    className="modern-select"
                                    value={approveFromDate === "null" ? "" : approveFromDate}
                                    onChange={(e) => setApproveFromDate(e.target.value || "null")}
                                />
                            </div>
                        </div>

                        <div className="filter-chip">
                            <div className="filter-chip-icon"><Clock size={13} /></div>
                            <div className="filter-chip-content">
                                <span className="filter-chip-label">Valid Upto</span>
                                <input
                                    type="date"
                                    className="modern-select"
                                    value={approveToDate === "null" ? "" : approveToDate}
                                    onChange={(e) => setApproveToDate(e.target.value || "null")}
                                />
                            </div>
                        </div>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => {
                                    setToggleCompany("null");
                                    setProject("null");
                                }}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Stats Summary - clickable toggles */}
            <div className="stats-minimal-row" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'all' ? 'stat-active' : ''}`}
                        onClick={() => setActiveStatFilter('all')}
                    >
                        <ShieldCheck size={14} />
                        <span>Total Insurance</span>
                        <strong>{totalCount}</strong>
                    </div>
                    <div className="stat-minimal-item">
                        <IndianRupee size={14} />
                        <span>Total Amount</span>
                        <strong>₹{totalAmount.toLocaleString()}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'expired' ? 'stat-active skipped' : ''}`}
                        onClick={() => handleStatClick('expired')}
                    >
                        <AlertCircle size={14} />
                        <span>Expired</span>
                        <strong>{expiredCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === 'active' ? 'stat-active achieved' : ''}`}
                        onClick={() => handleStatClick('active')}
                    >
                        <CheckCircle size={14} />
                        <span>Active</span>
                        <strong>{activeCount}</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button
                        className="toggle-filters-btn"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>

                    <div className="filter-actions-attractive">
                        <DownloadSiteProject progressdata={displayList} />
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper-minimal table-box scroll-container-table">
                {buffer ? (
                    <div className="loader-minimal">
                        <div className="spinner-minimal"></div>
                    </div>
                ) : (
                    <table className="progress-table-minimal">
                        <thead className="table-heading">
                            <tr>
                                <th className="col-sno" style={{ width: '5%' }}>#</th>
                                <th className="col-period" style={{ width: '18%' }}>PR No & Project</th>
                                <th className="col-period">Policy Details</th>
                                <th className="col-submitted text-center" style={{ width: '12%' }}>Amount</th>
                                <th className="col-approved text-center" style={{ width: '18%' }}>Validity</th>
                                <th className="col-status text-center" style={{ width: '10%' }}>Status</th>
                                <th className="col-action text-center" style={{ width: '8%' }}>Document</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayList.map((item, index) => (
                                <tr key={index} className={`progress-row ${item._category === 'expired' ? 'has-pending' : 'has-achieved'}`}>
                                    <td className="col-sno text-start">{index + 1}.</td>
                                    <td className="col-period">
                                        {item.project ? `${item.site_pr_code} & ${item.site_project_short_name}` : "-"}
                                    </td>
                                    <td className="col-period">
                                        <div style={{ fontWeight: 600, fontSize: '12px' }}>{item.insurance_name || "-"}</div>
                                        <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>Policy No: {item.insurance_policy_num || "-"}</div>
                                    </td>
                                    <td className="col-submitted text-center">
                                        <span className="badge-value">₹{item.insurance_amount ? Number(item.insurance_amount).toLocaleString() : "-"}</span>
                                    </td>
                                    <td className="col-approved">
                                        <div className="progress-badge">
                                            <span className="badge-label">Start</span>
                                            <span className="badge-value">{item.insurance_policy_start_date ? formattedDateLong(item.insurance_policy_start_date) : "-"}</span>
                                        </div>
                                        <div className="progress-badge approved">
                                            <span className="badge-label">Valid Upto</span>
                                            <span className="badge-value">{item.insurance_policy_valid_upto_date ? formattedDateLong(item.insurance_policy_valid_upto_date) : "-"}</span>
                                        </div>
                                    </td>
                                    <td className="col-status text-center">
                                        <span className={`status-badge-minimal ${item._category === 'expired' ? 'pending' : 'approved'}`}>
                                            {item._category === 'expired' ? 'Expired' : 'Active'}
                                        </span>
                                    </td>
                                    <td className="col-action text-center">
                                        {!item.insurance_file_upload ? (
                                            <span style={{ fontSize: '11px', color: '#cbd5e1', fontStyle: 'italic' }}>Not Attached</span>
                                        ) : (
                                            <a href={item.insurance_file_upload} target="blank" className="attachment-link">
                                                <FileCheck size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                                                View
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {displayList.length === 0 && (
                                <tr>
                                    <td colSpan={7}>
                                        <div className="empty-state-attractive">
                                            <div className="empty-state-icon-wrap">
                                                <ShieldCheck size={32} />
                                            </div>
                                            <h4 className="empty-state-title">No Insurance Records Found</h4>
                                            <p className="empty-state-subtitle">
                                                {activeStatFilter !== 'all'
                                                    ? "No records match this status. Try a different filter."
                                                    : "Try adjusting your filters or select a different project to view records."}
                                            </p>
                                            {(hasActiveFilters || activeStatFilter !== 'all') && (
                                                <button
                                                    className="empty-state-clear-btn"
                                                    onClick={() => {
                                                        setToggleCompany("null");
                                                        setProject("null");
                                                        setActiveStatFilter("all");
                                                    }}
                                                >
                                                    <X size={13} />
                                                    Clear Filters
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export { Progressreport, EOTDetails, COSDetails, MilestoneDetails, BillingDetailsProgress, BGDetails, InsuranceDetails }